import React from "react";
import { useBranding } from "@/context/BrandingContext";
import { API } from "@/lib/api";

function resolveLogoSrc(logoUrl) {
  if (!logoUrl) return "";
  if (logoUrl.startsWith("http")) return logoUrl;
  if (logoUrl.startsWith("/api")) return `${API}${logoUrl.slice(4)}`;
  return logoUrl;
}

export function LogoMark({ size = 40, className = "" }) {
  const branding = useBranding();
  const src = resolveLogoSrc(branding.logo_url);
  const letter = (branding.mark_letter || "P").slice(0, 1);
  const badge = branding.badge || "GX";

  return (
    <div
      className={`relative inline-flex shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid="logo-mark"
    >
      {src ? (
        <img src={src} alt="" className="h-full w-full rounded-[22%] object-cover" />
      ) : (
        <div
          className="flex h-full w-full items-center justify-center rounded-[22%] bg-primary text-primary-foreground font-display font-extrabold"
          style={{ fontSize: size * 0.55 }}
        >
          {letter}
        </div>
      )}
      <span
        className="absolute -right-1.5 -top-1.5 rounded-md bg-accent px-1 py-0.5 font-display text-[9px] font-bold leading-none text-white shadow-sm"
        data-testid="logo-badge"
      >
        {badge}
      </span>
    </div>
  );
}

export function LogoWordmark({ size = 40, className = "", subtitle = false }) {
  const branding = useBranding();
  const name = branding.product_name || "Pravadh GovernX";
  const parts = name.split(" ");
  const first = parts[0] || name;
  const rest = parts.slice(1).join(" ");

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="logo-wordmark">
      <LogoMark size={size} />
      <div className="flex flex-col leading-none">
        <span className="font-display text-lg font-bold tracking-tight">
          <span className="text-foreground">{first}</span>
          {rest ? <span className="text-primary"> {rest}</span> : null}
        </span>
        {subtitle && (
          <span className="mt-1 text-[10px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
            {branding.tagline || "Connect. Clean. Govern."}
          </span>
        )}
      </div>
    </div>
  );
}
